import React from 'react';
import styled, { withTheme } from 'styled-components'
import moment from 'moment'

import { Table, Loading } from '../common';
import { numberToCurrency } from 'vqp-common'
import { fetchClientDetail } from '../../redux/actions/clients';
import useFetch from '../../utils/useFetch'
import formatAddress from '../../utils/formatAddress'

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`

const Title = styled.div`
    font-size: 18px;
    font-weight: 700;
    color: ${props => props.theme.colors.textBold};
    margin-bottom: 20px;
` 


export const ClientDetailOrdersTable = withTheme( ({clientId, theme}) => {

    const orders = useFetch(fetchClientDetail, clientId)

    const columns = [
        {
            Header: 'Pedido',
            accessor: 'orderId',
            maxWidth: 70
        },
        {
            Header: 'Data',
            accessor: 'date',
            maxWidth: 80,
            Cell: props => (moment(props.value).format('DD/MM/YYYY'))
        },
        {
            Header: 'Endereço',
            accessor: 'address',
            Cell: props => formatAddress(props.value)
        },
        {
            Header: 'Desconto',
            accessor: 'discount',
            maxWidth: 80,
            Cell: props => (props.value > 0 ? numberToCurrency(props.value) : '-')
        },
        {
            Header: 'Total',
            accessor: 'value',
            maxWidth: 120,
            Cell: props => (numberToCurrency(props.value))
        }
    ]
    
    return (
        <Wrapper>
            <Title>Histórico de pedidos</Title>
            {orders.loading && (
                <Loading />
            )}
            {orders.response && (
                <Table
                    className="-striped"
                    data={orders.response}
                    columns={columns}
                    pageSize={6}
                    showPagination={true}
                    noDataText="Este cliente ainda não possui pedidos."
                    getTrProps={() => ({
                        style: {
                            borderBottom: `1px solid ${theme.colors.lightGrey}`
                        }
                    })}
                    getTheadProps={() => ({
                        style: {
                            color: theme.colors.textBold
                        }
                    })}
                />
            )}            
        </Wrapper>
    )
})

